export interface MetadataTypeCollection {
    Description: string;
    Types: TypeMetadata[];
}

export interface TypeMetadata {
    Name: string;
    Properties: PropertyMetadata[];
}

export interface PropertyMetadata {
    Name: string;
    Type: string;
    DisplayInfo: DisplayInfo;
}

export interface DisplayInfo {
    Required: boolean;
    Sensitive: boolean;
    Label: string;
    Description: string;
    // tslint:disable-next-line: no-any
    Options: any;
    ListApi: string;
    ReadOnly: boolean;
    ShowCopyToClipboard: boolean;
    PropertyApplicability?: PropertyApplicability;
    ConnectivityCheck?: ConnectivityCheck;
}

export enum PropertyApplicabilityMode {
    ApplicableIfHasAnyValue = "ApplicableIfHasAnyValue",
    ApplicableIfHasNoValue = "ApplicableIfHasNoValue",
    ApplicableIfSpecificValue = "ApplicableIfSpecificValue",
    ApplicableIfNotSpecificValue = "ApplicableIfNotSpecificValue",
}

export interface PropertyApplicability {
    Mode: PropertyApplicabilityMode;
    DependsOnPropertyName: string;
    // tslint:disable-next-line: no-any
    DependsOnPropertyValue: any;
}

export interface ConnectivityCheck {
    Title: string;
    Url: string;
    DependsOnPropertyNames: string[];
}

export enum ConnectivityCheckResponseMessageCategory {
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
}

export interface ConnectivityCheckResponseMessage {
    Category: ConnectivityCheckResponseMessageCategory;
    Message: string;
}

export interface ConnectivityCheckResponse {
    Messages: ConnectivityCheckResponseMessage[];
}

// tslint:disable-next-line: no-any
export type DataContext = Record<string, any>;
